import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('menu', '.header__menu');
loader('navbar', '.toggler');
loader('headerSlider', '.header-slider');
loader('accordion', '.faq');
loader('tab', '.tabs');
loader('trip', '.archive-trip');
loader('activitySlider', '.slider-activity');
loader('agenda', '.agenda');
